import { create } from 'zustand';
// TODO: 주석 필요
var account = create(function (set) { return ({
    account: {},
    setAccount: function (account) {
        set(function () { return ({
            account: account,
        }); });
    },
}); });
export var useAccountStore = account;
